import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomesticBankAccountFormModel } from './domestic-bank-account-form.model';
import { KontoBankowe } from '../../../../models/konto-bankowe';
import { SharedValidators } from '../../../../validators/shared-validators';

export class DomesticBankAccountFormBuilder {
  public static createFormGroup(
    bankAccount?: KontoBankowe,
  ): FormGroup<DomesticBankAccountFormModel> {
    return new FormGroup<DomesticBankAccountFormModel>({
      numerKonta: new FormControl(
        !bankAccount?.czyZagraniczne ? bankAccount?.numerKonta || null : null,
      ),
      nieJestWlascicielem: new FormControl(
        bankAccount?.nieJestWlascicielem || null,
      ),
      daneWlasciciela: new FormControl(bankAccount?.daneWlasciciela || null, [
        Validators.maxLength(150),
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.daneOsobowePatternValidator(),
      ]),
    });
  }

  public static toModel(
    formGroup: FormGroup<DomesticBankAccountFormModel>,
  ): KontoBankowe {
    const kontoBankowe = new KontoBankowe();

    kontoBankowe.numerKonta = formGroup.controls.numerKonta.value;
    kontoBankowe.nieJestWlascicielem =
      formGroup.controls.nieJestWlascicielem.value;
    kontoBankowe.daneWlasciciela = formGroup.controls.daneWlasciciela.value;
    kontoBankowe.czyZagraniczne = false;

    return kontoBankowe;
  }
}
